/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { AdDesignStorePathParams, AdDesignStoreRequest, AdDesignStoreResponse } from '../types/AdDesignStore'

/**
 * POST /organisations/:organisation/ad-designs
 * @see backend/nexus/modules/Organisation/Http/Controllers/AdDesignController.php AdDesignController::store
 */
export async function adDesignStore(
	organisation: AdDesignStorePathParams['organisation'],
	data: AdDesignStoreRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AdDesignStoreResponse>> {
	return axiosInstance.post(`/organisations/${organisation}/ad-designs`, data, config)
}
